module.exports = __webpack_public_path__ + "./fonts/Montserrat-BlackItalic.ttf";